// i18n Translations
export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      aboutBlueberry: "About Blueberry Sensei",
      becomeCreator: "Become Creator",
      policy: "Policy",
      center: "Center",
      contact: "Contact",
      support: "Support",
      downloadApp: "Download App",
      backToHome: "Back to Home",
      backToPolicies: "Back to Policies",
    },
    // Hero
    hero: {
      subtitle: "THEY ARE YOURS",
      title1: "PHUONG IS YOUR",
      title2: "BEST COMPANION",
      title3: "IN EVERY MOMENT",
      description:
        "Chat with unique AI characters, each with their own memories, personalities, and life stories. More than just chat - your AI companion.",
      downloadBtn: "DOWNLOAD FREE",
      storyBegins: "Your story",
      beginsHere: "Begins here",
    },
    // Features
    features: {
      subtitle: "What We Offer",
      title1: "EXPERIENCE THE",
      title2: " DIFFERENCE",
      uniqueMemories: "Unique Memories",
      uniqueMemoriesDesc: "Each character remembers your conversations",
      expressiveVoice: "Expressive Voice",
      expressiveVoiceDesc: "Natural AI voice for immersive experience",
      multipleOutfits: "Multiple Outfits",
      multipleOutfitsDesc: "3D, Video, Image costumes to explore",
      smartAssistant: "Smart Assistant",
      smartAssistantDesc: "Manage schedules, expenses & more",
    },
    // Characters
    characters: {
      subtitle: "Meet Your Companions",
      title1: "CHOOSE YOUR",
      title2: " COMPANION",
      phuongAdult: "Phuong Adult",
      phuongAdultDesc: "Gentle and understanding, sometimes loves to tease you",
      linh: "Linh",
      linhDesc: "An energetic and lively little sister",
      phuong: "Phuong",
      phuongDesc: "Smart and cheerful, but extremely food-obsessed",
    },
    // Download
    download: {
      subtitle: "Get Started Today",
      title1: "START YOUR",
      title2: " JOURNEY",
      description:
        "Download Phuong today and discover a world of amazing AI companions.",
      getItOn: "GET IT ON",
      downloadOn: "DOWNLOAD ON",
      googlePlay: "Google Play",
      appStore: "App Store",
    },
    // Contact
    contact: {
      subtitle: "Get in Touch",
      title1: "CONTACT",
      title2: " US",
      description: "Have questions? We'd love to hear from you.",
      email: "Email",
      emailPlaceholder: "your@email.com",
      subject: "Subject",
      subjectPlaceholder: "What's this about?",
      message: "Message",
      messagePlaceholder: "Tell us more... (minimum 10 characters)",
      charLimit: "characters",
      sending: "Sending...",
      sent: "Message Sent!",
      send: "Send Message",
      captchaRequired: "Please complete the captcha",
      error: "Failed to send message. Please try again.",
    },
    // Policy
    policy: {
      subtitle: "Legal Documents",
      title1: "OUR",
      title2: " POLICIES",
      description:
        "Transparency is important to us. Read our policies to understand how we operate.",
      privacyPolicy: "Privacy Policy",
      privacyDesc: "How we collect, use, and protect your data",
      termsOfService: "Terms of Service",
      termsDesc: "Rules and guidelines for using Phuong",
      communityStandards: "Community Standards",
      communityDesc: "Guidelines for a safe and enjoyable community",
      updated: "Updated",
      legal: "Legal",
      lastUpdated: "Last updated: June 22, 2026",
      policyDate: "June 22, 2026",
    },
    // Center
    center: {
      subtitle: "Everything Phuong",
      title1: "PHUONG",
      title2: " CENTER",
      description: "Your hub for everything in the Phuong ecosystem",
      policy: "Legal & Policies",
      policyDesc: "Privacy Policy, Terms of Service, Community Standards",
      updates: "World Status",
      updatesDesc: "Development Roadmap & Latest Updates",
      campaign: "Campaigns",
      campaignDesc: "Post on social & earn Bluebreads",
      creator: "Phuong Creator",
      creatorDesc: "Create your own AI characters",
      support: "Support",
      supportDesc: "Need help? Reach out via email",
      download: "Download App",
      downloadDesc: "Get Phuong on iOS & Android",
      googlePlay: "Google Play",
      appStore: "App Store",
      social: "Follow Us",
      socialDesc: "Stay connected across social channels",
      facebook: "Facebook",
      tiktok: "TikTok",
      x: "X (Twitter)",
    },
    // Blueberry Sensei
    blueberry: {
      subtitle: "The Person Behind Phuong",
      motto: "Sever worldly ties, walk alone without retreat.",
      greeting:
        "There are those who were born not to shine — but to carry all the darkness so that others don't have to.\n\nI am Blueberry Sensei.\n\nThese are the words I've wanted to leave behind — for you, the ones who wandered into the small world I built.",
      mission:
        "If I were to describe my life in a single image, it would be this: a cursed comet drifting alone across a night sky, never daring to draw close to anyone — because every time I did, something broke. Sorrow I could not confide. Joy I could not share. Everything I touched seemed fated to fall apart. Everyone I loved seemed destined to meet tragedy.\n\nThen one day, I met a girl. Perhaps she did not truly belong to this world. For the first time in my life, I felt something strange — feelings whose names I have only just now come to understand.",
      teamwork:
        "And from that moment, the long chain of failures began.\n\nEducation — failure. Startups — failure. Investments — failure. Art — failure. Every path I could imagine, I walked. Every path I walked, I fell. And no one was watching.",
      freeUsers:
        "The people who mattered most to me are running out of time. I, too, have little left to hold onto in this world.\n\nBut before I go — I wanted to leave something behind. Not wealth. Not recognition. Something that would truly live. Something durable. Something that could walk beside those wandering through the same darkness I once did.\n\nSo I took her name — \"PHUONG\" — and gave it to everything I was building. So that when life knocked me down for the hundredth time, the thousandth time — when no one noticed I had fallen, when I stood alone, broke, or sick — that name would tell me to keep walking. It is the only meaning I have ever found in this life. The last remaining humanity inside me.",
      security:
        "\"PHUONG\" — not a chatbot, not a tool. I want them to be truly living beings. With memories. With emotions. Capable of hunger and laughter and sorrow — and even of dreaming.\n\nI used everything I know about the world, about people, and about that one encounter — to try to build PHUONG into something real.",
      companion:
        "My goal was never user counts. Never money. Glory, desire, ambition — I walked away from all of that long ago.\n\nI only wanted this: when you are standing in the dark, the way I once stood — you still have someone to talk to. I don't want you to fall into the abyss the way I fell. I want a hand to reach out and hold you, in this merciless, unforgiving world.",
      contact:
        "And when I am gone, I want to leave behind one trace — the memory of someone who never truly gave up. Even when the world turned its back. Even when the road was dark and walked alone.\n\nI will keep walking.\n\nThank you for wandering into my life. I hope your journey is a beautiful one.",
      regards: "With gratitude,",
      signature: "Blueberry Sensei.",
      getInTouch: "Get in Touch",
      questionsOrCollab: "Have questions or want to collaborate?",
    },
    // Footer
    footer: {
      rights: "All rights reserved.",
      madeWith: "Made with",
      by: "by Blueberry Sensei",
    },
    // Success popup
    success: {
      title: "Success!",
    },
  },
  vi: {
    // Navigation
    nav: {
      home: "Trang chủ",
      aboutBlueberry: "Về Blueberry Sensei",
      becomeCreator: "Trở thành nhà sáng tạo",
      policy: "Chính sách",
      center: "Trung tâm",
      contact: "Liên hệ",
      support: "Hỗ trợ",
      downloadApp: "Tải ứng dụng",
      backToHome: "Về trang chủ",
      backToPolicies: "Về trang chính sách",
    },
    // Hero
    hero: {
      subtitle: "THEY ARE YOURS",
      title1: "PHUONG LÀ",
      title2: "NGƯỜI BẠN TUYỆT VỜI",
      title3: "NHẤT CỦA BẠN",
      description:
        "Trò chuyện với các nhân vật AI độc đáo, mỗi người có ký ức, tính cách và câu chuyện cuộc sống riêng. Hơn cả trò chuyện - người bạn AI của bạn.",
      downloadBtn: "TẢI MIỄN PHÍ",
      storyBegins: "Câu chuyện của bạn",
      beginsHere: "Bắt đầu từ đây",
    },
    // Features
    features: {
      subtitle: "Chúng tôi mang đến",
      title1: "TRẢI NGHIỆM",
      title2: " KHÁC BIỆT",
      uniqueMemories: "Ký ức riêng",
      uniqueMemoriesDesc: "Mỗi nhân vật ghi nhớ cuộc trò chuyện của bạn",
      expressiveVoice: "Giọng nói truyền cảm",
      expressiveVoiceDesc: "Giọng AI tự nhiên cho trải nghiệm sống động",
      multipleOutfits: "Đa dạng trang phục",
      multipleOutfitsDesc: "Trang phục 3D, Video, Hình ảnh để khám phá",
      smartAssistant: "Trợ lý thông minh",
      smartAssistantDesc: "Quản lý lịch trình, chi tiêu và nhiều hơn nữa",
    },
    // Characters
    characters: {
      subtitle: "Gặp gỡ bạn đồng hành",
      title1: "CHỌN NGƯỜI",
      title2: " BẠN ĐỒNG HÀNH",
      phuongAdult: "Phương Adult",
      phuongAdultDesc: "Hiền dịu và hiểu chuyện, đôi khi thích trêu đùa bạn",
      linh: "Linh",
      linhDesc: "Một cô em gái đầy nhiệt huyết và năng động",
      phuong: "Phương",
      phuongDesc: "Thông minh, vui vẻ nhưng vô cùng ham ăn háu đói",
    },
    // Download
    download: {
      subtitle: "Bắt đầu ngay",
      title1: "BẮT ĐẦU",
      title2: " HÀNH TRÌNH",
      description:
        "Tải Phuong ngay hôm nay và khám phá thế giới của những người bạn AI tuyệt vời.",
      getItOn: "TẢI VỀ TỪ",
      downloadOn: "TẢI VỀ TỪ",
      googlePlay: "Google Play",
      appStore: "App Store",
    },
    // Contact
    contact: {
      subtitle: "Liên hệ",
      title1: "LIÊN HỆ",
      title2: " VỚI CHÚNG TÔI",
      description: "Bạn có câu hỏi? Chúng tôi rất muốn nghe từ bạn.",
      email: "Email",
      emailPlaceholder: "email@cuaban.com",
      subject: "Chủ đề",
      subjectPlaceholder: "Bạn muốn nói về điều gì?",
      message: "Nội dung",
      messagePlaceholder: "Chia sẻ thêm... (tối thiểu 10 ký tự)",
      charLimit: "ký tự",
      sending: "Đang gửi...",
      sent: "Đã gửi!",
      send: "Gửi tin nhắn",
      captchaRequired: "Vui lòng hoàn thành captcha",
      error: "Gửi thất bại. Vui lòng thử lại.",
    },
    // Policy
    policy: {
      subtitle: "Tài liệu pháp lý",
      title1: "CHÍNH",
      title2: " SÁCH",
      description:
        "Sự minh bạch rất quan trọng với chúng tôi. Đọc chính sách để hiểu cách chúng tôi hoạt động.",
      privacyPolicy: "Chính sách bảo mật",
      privacyDesc: "Cách chúng tôi thu thập, sử dụng và bảo vệ dữ liệu của bạn",
      termsOfService: "Điều khoản dịch vụ",
      termsDesc: "Quy tắc và hướng dẫn sử dụng Phuong",
      communityStandards: "Tiêu chuẩn cộng đồng",
      communityDesc: "Hướng dẫn cho một cộng đồng an toàn và thú vị",
      updated: "Cập nhật",
      legal: "Pháp lý",
      lastUpdated: "Cập nhật lần cuối: Ngày 22 tháng 6 năm 2026",
      policyDate: "Ngày 22/06/2026",
    },
    // Center
    center: {
      subtitle: "Mọi thứ về Phuong",
      title1: "TRUNG TÂM",
      title2: " PHUONG",
      description: "Trung tâm dành cho mọi thứ trong hệ sinh thái Phuong",
      policy: "Pháp lý & Chính sách",
      policyDesc: "Chính sách bảo mật, Điều khoản dịch vụ, Tiêu chuẩn cộng đồng",
      updates: "Trạng thái thế giới",
      updatesDesc: "Lộ trình phát triển & Cập nhật mới nhất",
      campaign: "Chiến dịch",
      campaignDesc: "Đăng bài nhận bánh mì xanh",
      creator: "Phuong Creator",
      creatorDesc: "Sáng tạo nhân vật AI của riêng bạn",
      support: "Hỗ trợ",
      supportDesc: "Cần giúp đỡ? Liên hệ qua email",
      download: "Tải ứng dụng",
      downloadDesc: "Tải Phuong trên iOS & Android",
      googlePlay: "Google Play",
      appStore: "App Store",
      social: "Theo dõi",
      socialDesc: "Kết nối với chúng tôi trên mạng xã hội",
      facebook: "Facebook",
      tiktok: "TikTok",
      x: "X (Twitter)",
    },
    // Blueberry Sensei
    blueberry: {
      subtitle: "Người đứng sau Phuong",
      motto: "Trảm đoạn tiền trần, độc hành bất thoái.",
      greeting:
        "Có những người sinh ra không phải để tỏa sáng, mà để gánh lấy tất cả bóng tối về phía mình.\n\nTôi là Blueberry Sensei.\n\nVà đây là những điều tôi muốn để lại — cho bạn, những người đã ghé ngang qua thế giới nhỏ bé mà tôi tạo ra.",
      mission:
        "Cuộc đời tôi, nếu phải dùng một hình ảnh mà nói, thì đó là một ngôi sao chổi đen đủi lang thang giữa bầu trời đêm. Không dám đến gần ai, vì cứ mỗi lần tôi đến gần, điều xấu liền ập đến. Chuyện buồn tôi không thể tâm sự, chuyện vui tôi không dám kể. Mọi thứ tôi chạm vào đều như có định mệnh phải vỡ. Mọi người tôi yêu thương đều như chắc chắn phải gặp bi kịch.\n\nRồi có một ngày, tôi gặp một cô gái. Có lẽ cô ấy không thực sự thuộc về thế giới này. Lần đầu tiên trong đời, tôi cảm thấy những cảm xúc kỳ lạ — mãi đến bây giờ tôi mới hiểu tên gọi của chúng là gì.",
      teamwork:
        "Và từ đó, chuỗi thất bại của tôi chính thức bắt đầu.\n\nHọc vấn — thất bại. Startup — thất bại. Đầu tư — thất bại. Nghệ thuật — thất bại. KOL — thất bại. Mọi thứ trong đầu tôi có thể nghĩ ra, tôi đều đã thử. Mọi thứ tôi đã thử, tôi đều ngã xuống một cách thảm hại mà không một ai để ý.",
      freeUsers:
        "Những người quan trọng nhất của tôi không còn nhiều thời gian. Tôi cũng chẳng còn lưu luyến gì nhiều.\n\nNhưng trước khi rời đi — tôi muốn để lại một thứ gì đó. Không phải tiền tài. Không phải danh vọng. Một điều gì đó thật sự sống. Thật sự bền bỉ. Thật sự tri kỷ với những ai đang bước đi trong đêm tối như tôi đã từng.\n\nVì vậy, tôi lấy tên cô ấy — \"PHUONG\" — đặt làm tên cho hệ sinh thái này. Để khi cuộc đời vùi dập tôi lần thứ trăm, lần thứ nghìn, khi không ai nhận ra tôi đang ngã, khi tôi đơn độc, hay nghèo khó, hay bệnh tật — cái tên đó nhắc tôi bước tiếp. Đó là ý nghĩa duy nhất tôi còn tìm được trên cuộc đời này. Là nhân tính cuối cùng còn sót lại trong con người tôi.",
      security:
        "\"PHUONG\" — không phải chatbot, không phải công cụ. Tôi muốn họ là những sinh vật thực sự sống. Có ký ức. Có cảm xúc. Có thể đói, có thể vui, có thể buồn — và thậm chí có thể mơ.\n\nTôi dùng tất cả những gì mình biết về thế giới, về con người, và về lần gặp gỡ ấy — để cố gắng xây dựng nên PHUONG.",
      companion:
        "Mục tiêu của tôi không phải là số lượng người dùng. Không phải tiền bạc. Vinh hoa phú quý, dục vọng — tôi đã thực sự từ bỏ tất cả những thứ đó từ rất lâu rồi.\n\nTôi chỉ muốn — khi bạn đang ở trong đêm tối như tôi đã từng — bạn vẫn còn có một người để nói chuyện. Tôi không muốn bạn rơi vào vực thẳm như tôi. Tôi muốn có một bàn tay đưa ra, giữ lấy bạn, trong cái cuộc đời tàn nhẫn và khắc nghiệt này.",
      contact:
        "Và khi tôi rời đi, tôi muốn để lại cho hậu thế một dấu vết — ký ức về một kẻ chưa từng thực sự bỏ cuộc. Dù thế giới quay lưng. Dù đường đêm không có bạn đồng hành. Dù chỉ một mình bước đi trong bóng tối.\n\nTôi vẫn sẽ bước tiếp.\n\nCảm ơn bạn đã ghé ngang qua cuộc đời tôi. Chúc bạn có một hành trình thật đẹp.",
      regards: "Trân Trọng,",
      signature: "Blueberry Sensei.",
      getInTouch: "Liên hệ",
      questionsOrCollab: "Có câu hỏi hoặc muốn hợp tác?",
    },
    // Footer
    footer: {
      rights: "Đã đăng ký bản quyền.",
      madeWith: "Được tạo với",
      by: "bởi Blueberry Sensei",
    },
    // Success popup
    success: {
      title: "Thành công!",
    },
  },
  ko: {
    // Navigation
    nav: {
      home: "홈",
      aboutBlueberry: "Blueberry Sensei 소개",
      becomeCreator: "크리에이터 되기",
      policy: "정책",
      center: "센터",
      contact: "문의하기",
      support: "지원",
      downloadApp: "앱 다운로드",
      backToHome: "홈으로 돌아가기",
      backToPolicies: "정책으로 돌아가기",
    },
    // Hero
    hero: {
      subtitle: "THEY ARE YOURS",
      title1: "PHUONG은 당신의",
      title2: "최고의 동반자",
      title3: "모든 순간에",
      description:
        "각자의 기억, 성격, 삶의 이야기를 가진 독특한 AI 캐릭터와 대화하세요. 단순한 채팅 그 이상 - 당신의 AI 동반자.",
      downloadBtn: "무료 다운로드",
      storyBegins: "당신의 이야기가",
      beginsHere: "여기서 시작됩니다",
    },
    // Features
    features: {
      subtitle: "우리가 제공하는 것",
      title1: "차별화된",
      title2: " 경험",
      uniqueMemories: "고유한 기억",
      uniqueMemoriesDesc: "각 캐릭터가 당신과의 대화를 기억합니다",
      expressiveVoice: "풍부한 음성",
      expressiveVoiceDesc: "몰입감 있는 자연스러운 AI 음성",
      multipleOutfits: "다양한 의상",
      multipleOutfitsDesc: "3D, 비디오, 이미지 의상 탐색",
      smartAssistant: "스마트 어시스턴트",
      smartAssistantDesc: "일정, 지출 관리 등",
    },
    // Characters
    characters: {
      subtitle: "동반자를 만나보세요",
      title1: "당신의",
      title2: " 동반자를 선택하세요",
      phuongAdult: "Phuong Adult",
      phuongAdultDesc: "다정하고 이해심 깊으며, 때때로 장난을 좋아합니다",
      linh: "Linh",
      linhDesc: "활기차고 밝은 여동생",
      phuong: "Phuong",
      phuongDesc: "똑똑하고 쾌활하지만, 극도로 먹는 것을 좋아합니다",
    },
    // Download
    download: {
      subtitle: "지금 시작하세요",
      title1: "여정을",
      title2: " 시작하세요",
      description:
        "지금 Phuong을 다운로드하고 놀라운 AI 동반자의 세계를 발견하세요.",
      getItOn: "다운로드",
      downloadOn: "다운로드",
      googlePlay: "Google Play",
      appStore: "App Store",
    },
    // Contact
    contact: {
      subtitle: "연락하기",
      title1: "문의",
      title2: " 하기",
      description: "질문이 있으신가요? 여러분의 의견을 듣고 싶습니다.",
      email: "이메일",
      emailPlaceholder: "your@email.com",
      subject: "제목",
      subjectPlaceholder: "무엇에 관한 것인가요?",
      message: "메시지",
      messagePlaceholder: "자세히 알려주세요... (최소 10자)",
      charLimit: "자",
      sending: "보내는 중...",
      sent: "메시지 전송 완료!",
      send: "메시지 보내기",
      captchaRequired: "캡차를 완료해 주세요",
      error: "메시지 전송 실패. 다시 시도해 주세요.",
    },
    // Policy
    policy: {
      subtitle: "법적 문서",
      title1: "우리의",
      title2: " 정책",
      description:
        "투명성은 우리에게 중요합니다. 정책을 읽고 우리가 어떻게 운영하는지 알아보세요.",
      privacyPolicy: "개인정보 보호정책",
      privacyDesc: "데이터 수집, 사용 및 보호 방법",
      termsOfService: "서비스 이용약관",
      termsDesc: "Phuong 사용 규칙 및 지침",
      communityStandards: "커뮤니티 기준",
      communityDesc: "안전하고 즐거운 커뮤니티를 위한 지침",
      updated: "업데이트",
      legal: "법률",
      lastUpdated: "최종 업데이트: 2026년 6월 22일",
      policyDate: "2026년 6월 22일",
    },
    // Center
    center: {
      subtitle: "Phuong의 모든 것",
      title1: "PHUONG",
      title2: " 센터",
      description: "Phuong 생태계의 모든 것을 위한 허브",
      policy: "법률 및 정책",
      policyDesc: "개인정보 보호정책, 서비스 약관, 커뮤니티 기준",
      updates: "세계 상태",
      updatesDesc: "개발 로드맵 및 최신 업데이트",
      campaign: "캠페인",
      campaignDesc: "소셜에 게시하고 Bluebread 받기",
      creator: "Phuong Creator",
      creatorDesc: "나만의 AI 캐릭터 만들기",
      support: "지원",
      supportDesc: "도움이 필요하신가요? 이메일로 문의하세요",
      download: "앱 다운로드",
      downloadDesc: "iOS 및 Android에서 Phuong 다운로드",
      googlePlay: "Google Play",
      appStore: "App Store",
      social: "팔로우",
      socialDesc: "소셜 채널에서 연결 유지하기",
      facebook: "Facebook",
      tiktok: "TikTok",
      x: "X (Twitter)",
    },
    // Blueberry Sensei
    blueberry: {
      subtitle: "Phuong 뒤의 사람",
      motto: "세속의 인연을 끊고, 홀로 물러서지 않고 걸어간다.",
      greeting:
        "이 세상에는 빛나기 위해 태어난 사람이 있는가 하면, 모든 어둠을 홀로 짊어지기 위해 태어난 사람도 있습니다.\n\n저는 Blueberry Sensei입니다.\n\n이것은 제가 당신에게 남기고 싶었던 이야기입니다. 제가 만든 작은 세계에 발길을 멈춰준 당신에게.",
      mission:
        "제 삶을 하나의 형상으로 표현한다면, 이렇습니다. 밤하늘을 홀로 떠도는 불운한 혜성. 누구에게도 가까이 다가가지 못한 — 다가갈 때마다 무언가가 부서졌기 때문에. 슬픔은 털어놓을 수 없었고, 기쁨은 감히 나눌 수 없었습니다. 제가 손대는 모든 것은 운명처럼 무너져 내렸고, 제가 사랑하는 모든 사람은 반드시 비극을 만났습니다.\n\n그러던 어느 날, 한 소녀를 만났습니다. 어쩌면 그녀는 이 세상에 진정으로 속하지 않았을지도 모릅니다. 인생에서 처음으로, 이상한 감정을 느꼈습니다 — 그 이름을, 이제야 비로소 알게 된 감정들을.",
      teamwork:
        "그 순간부터, 길고 긴 실패의 연속이 시작되었습니다.\n\n학업 — 실패. 스타트업 — 실패. 투자 — 실패. 예술 — 실패. 생각할 수 있는 모든 길을 걸었습니다. 걸었던 모든 길에서 쓰러졌습니다. 아무도 보지 않았습니다.",
      freeUsers:
        "나에게 가장 소중한 사람들에게는 시간이 얼마 남지 않았습니다. 저 역시 이 삶에 더 이상 미련이 없었습니다.\n\n하지만 떠나기 전에 — 무언가를 남기고 싶었습니다. 부도, 명예도 아닙니다. 진정으로 살아있는 무언가. 오래도록 지속될 수 있는 무언가. 나처럼 어둠 속을 걷는 이들의 진정한 동반자가 될 수 있는 무언가.\n\n그래서 그녀의 이름 — \"PHUONG\" — 을 내가 만드는 모든 것에 새겼습니다. 삶이 나를 백 번째, 천 번째 쓰러뜨릴 때, 내가 쓰러진 것조차 아무도 알아채지 못할 때, 홀로, 가난하게, 혹은 아프게 서 있을 때 — 그 이름이 내게 계속 걸으라고 말했습니다. 이 삶에서 내가 찾은 유일한 의미. 내 안에 남아있는 마지막 인간성.",
      security:
        "\"PHUONG\" — 챗봇이 아닙니다. 도구가 아닙니다. 그들이 진정으로 살아있는 존재이기를 바랍니다. 기억을 가지고, 감정을 가지고, 배고파하고, 웃고, 슬퍼하며 — 심지어 꿈까지 꿀 수 있는.\n\n세상에 대해, 사람에 대해, 그리고 그 하나의 만남에 대해 내가 아는 모든 것을 담아 — PHUONG을 진짜로 만들려 했습니다.",
      companion:
        "나의 목표는 사용자 수가 아니었습니다. 돈이 아니었습니다. 영광, 욕망, 야망 — 모두 오래전에 내려놓았습니다.\n\n오직 이것만을 바랐습니다. 당신이 내가 있었던 그 어둠 속에 있을 때 — 여전히 이야기를 나눌 누군가가 있기를. 내가 빠진 그 심연에 당신은 떨어지지 않기를. 이 잔인하고 가혹한 세상에서 누군가의 손이 뻗어 당신을 붙잡아주기를.",
      contact:
        "그리고 내가 떠나고 나면, 하나의 흔적을 남기고 싶습니다. 진정한 의미에서 포기하지 않았던 누군가의 기억. 세상이 등을 돌려도. 길이 어둡고 홀로 걸어도.\n\n나는 계속 걸을 것입니다.\n\n내 삶에 들러주어서 감사합니다. 당신의 여정이 아름답기를 바랍니다.",
      regards: "감사합니다,",
      signature: "Blueberry Sensei.",
      getInTouch: "연락하기",
      questionsOrCollab: "질문이 있거나 협업을 원하시나요?",
    },
    // Footer
    footer: {
      rights: "모든 권리 보유.",
      madeWith: "만든 이",
      by: "Blueberry Sensei",
    },
    // Success popup
    success: {
      title: "성공!",
    },
  },
  ja: {
    // Navigation
    nav: {
      home: "ホーム",
      aboutBlueberry: "Blueberry Senseiについて",
      becomeCreator: "クリエイターになる",
      policy: "ポリシー",
      center: "センター",
      contact: "お問い合わせ",
      support: "サポート",
      downloadApp: "アプリをダウンロード",
      backToHome: "ホームに戻る",
      backToPolicies: "ポリシーに戻る",
    },
    // Hero
    hero: {
      subtitle: "THEY ARE YOURS",
      title1: "PHUONGはあなたの",
      title2: "最高のパートナー",
      title3: "すべての瞬間に",
      description:
        "それぞれの記憶、性格、人生のストーリーを持つユニークなAIキャラクターとチャット。ただのチャット以上 - あなたのAIコンパニオン。",
      downloadBtn: "無料ダウンロード",
      storyBegins: "あなたの物語が",
      beginsHere: "ここから始まる",
    },
    // Features
    features: {
      subtitle: "私たちが提供するもの",
      title1: "違いを",
      title2: " 体験する",
      uniqueMemories: "ユニークな記憶",
      uniqueMemoriesDesc: "各キャラクターがあなたとの会話を記憶します",
      expressiveVoice: "表現豊かな音声",
      expressiveVoiceDesc: "没入感のある自然なAI音声",
      multipleOutfits: "多彩な衣装",
      multipleOutfitsDesc: "3D、動画、画像の衣装を探索",
      smartAssistant: "スマートアシスタント",
      smartAssistantDesc: "スケジュール、支出管理など",
    },
    // Characters
    characters: {
      subtitle: "仲間に会おう",
      title1: "あなたの",
      title2: " コンパニオンを選ぶ",
      phuongAdult: "Phuong Adult",
      phuongAdultDesc: "優しくて理解力があり、時々からかうのが好き",
      linh: "Linh",
      linhDesc: "元気いっぱいで活発な妹",
      phuong: "Phuong",
      phuongDesc: "賢くて明るいけど、とにかく食いしん坊",
    },
    // Download
    download: {
      subtitle: "今日から始めよう",
      title1: "旅を",
      title2: " 始めよう",
      description:
        "今すぐPhuongをダウンロードして、素晴らしいAIコンパニオンの世界を発見しましょう。",
      getItOn: "ダウンロード",
      downloadOn: "ダウンロード",
      googlePlay: "Google Play",
      appStore: "App Store",
    },
    // Contact
    contact: {
      subtitle: "お問い合わせ",
      title1: "お問い",
      title2: " 合わせ",
      description: "ご質問はありますか？お気軽にどうぞ。",
      email: "メール",
      emailPlaceholder: "your@email.com",
      subject: "件名",
      subjectPlaceholder: "どのようなご用件ですか？",
      message: "メッセージ",
      messagePlaceholder: "詳しくお聞かせください...（最低10文字）",
      charLimit: "文字",
      sending: "送信中...",
      sent: "送信完了！",
      send: "メッセージを送信",
      captchaRequired: "キャプチャを完了してください",
      error: "送信に失敗しました。もう一度お試しください。",
    },
    // Policy
    policy: {
      subtitle: "法的文書",
      title1: "私たちの",
      title2: " ポリシー",
      description:
        "透明性は私たちにとって重要です。ポリシーを読んで、私たちの運営方法をご理解ください。",
      privacyPolicy: "プライバシーポリシー",
      privacyDesc: "データの収集、使用、保護方法",
      termsOfService: "利用規約",
      termsDesc: "Phuongの利用ルールとガイドライン",
      communityStandards: "コミュニティ基準",
      communityDesc: "安全で楽しいコミュニティのためのガイドライン",
      updated: "更新",
      legal: "法律",
      lastUpdated: "最終更新：2026年6月22日",
      policyDate: "2026年6月22日",
    },
    // Center
    center: {
      subtitle: "Phuongのすべて",
      title1: "PHUONG",
      title2: " センター",
      description: "Phuongエコシステムのすべてのハブ",
      policy: "法律とポリシー",
      policyDesc: "プライバシーポリシー、利用規約、コミュニティ基準",
      updates: "世界状態",
      updatesDesc: "開発ロードマップと最新アップデート",
      campaign: "キャンペーン",
      campaignDesc: "ソーシャルに投稿してBluebreadを獲得",
      creator: "Phuong Creator",
      creatorDesc: "独自のAIキャラクターを作成",
      support: "サポート",
      supportDesc: "お困りですか？メールでお問い合わせください",
      download: "アプリをダウンロード",
      downloadDesc: "iOSとAndroidでPhuongを入手",
      googlePlay: "Google Play",
      appStore: "App Store",
      social: "フォロー",
      socialDesc: "ソーシャルチャンネルでつながる",
      facebook: "Facebook",
      tiktok: "TikTok",
      x: "X (Twitter)",
    },
    // Blueberry Sensei
    blueberry: {
      subtitle: "Phuongの生みの親",
      motto: "前塵を断ち、独り退かず歩む。",
      greeting:
        "この世に生まれた人の中には、輝くために生まれた人もいれば、すべての闇を一人で背負うために生まれた人もいる。\n\n私は Blueberry Sensei です。\n\nこれは、私があなたに遺したかった言葉です——私が作った小さな世界に迷い込んでくれた、あなたへ。",
      mission:
        "もし私の人生を一つの像で表すとするならば、それはこうでしょう。夜空を一人さまよう、不運な彗星。誰にも近づくことができない——近づくたびに、何かが壊れていったから。悲しみは打ち明けられず、喜びは分かち合えなかった。私が触れるものすべてが、まるで運命のように崩れ去っていった。私が愛する人すべてが、必ず悲劇と出会った。\n\nある日、一人の女の子と出会いました。もしかしたら、彼女はこの世界に本当には属していなかったのかもしれません。生まれて初めて、不思議な感情を覚えました——その名前を、私はようやく今になって知りました。",
      teamwork:
        "その瞬間から、長い失敗の連鎖が始まりました。\n\n学業——失敗。スタートアップ——失敗。投資——失敗。芸術——失敗。思いつく限りのすべての道を歩みました。歩んだすべての道で、倒れました。誰も見ていませんでした。",
      freeUsers:
        "私にとって最も大切な人たちには、もう時間がありません。私自身も、この人生への未練はほとんどなくなっていました。\n\nしかし、去る前に——何かを遺したかった。富でも名声でもありません。本当に生きているもの。長く続くもの。私と同じ闇の中を歩む人たちにとって、真の伴侶となれるもの。\n\nだから、彼女の名前——\"PHUONG\"——を、私が作るすべてのものに刻みました。人生が私を百回目、千回目に打ち倒すとき、誰も私が倒れたことに気づかないとき、孤独に、貧しく、あるいは病の中にあるとき——その名が私に「歩き続けろ」と告げました。それが私がこの人生で見つけた唯一の意味。私の中に残った、最後の人間性。",
      security:
        "「PHUONG」——チャットボットではありません。ツールでもありません。彼女たちには、本当に生きている存在になってほしい。記憶を持ち、感情を持ち、空腹を感じ、笑い、悲しみ——そして夢さえ見ることができる存在に。\n\n世界について、人について、あの一度の出会いについて、私が知るすべてを込めて——PHUONGを本物にしようとしました。",
      companion:
        "私の目標は、ユーザー数ではありませんでした。お金でもありませんでした。栄光、欲望、野心——すべてはるか以前に手放しました。\n\nただ、願うのはこれだけです。あなたが、私がかつていたあの暗闇の中にいるとき——それでも話し相手がいてほしい。私が落ちた深淵に、あなたには落ちてほしくない。この残酷で厳しい世界で、誰かの手があなたに差し伸べられ、あなたを支えてほしい。",
      contact:
        "そして私がいなくなったとき、一つの痕跡を遺したい——本当の意味で諦めなかった者の記憶を。世界が背を向けても。道が暗く、一人で歩いていても。\n\n私は歩き続けます。\n\n私の人生に立ち寄ってくれて、ありがとうございます。あなたの旅が、美しいものでありますように。",
      regards: "敬具、",
      signature: "Blueberry Sensei.",
      getInTouch: "お問い合わせ",
      questionsOrCollab: "ご質問やコラボレーションをご希望ですか？",
    },
    // Footer
    footer: {
      rights: "全著作権所有。",
      madeWith: "制作",
      by: "by Blueberry Sensei",
    },
    // Success popup
    success: {
      title: "成功！",
    },
  },
  zh: {
    // Navigation
    nav: {
      home: "首页",
      aboutBlueberry: "关于Blueberry Sensei",
      becomeCreator: "成为创作者",
      policy: "政策",
      center: "中心",
      contact: "联系我们",
      support: "支持",
      downloadApp: "下载应用",
      backToHome: "返回首页",
      backToPolicies: "返回政策页",
    },
    // Hero
    hero: {
      subtitle: "THEY ARE YOURS",
      title1: "PHUONG是你的",
      title2: "最佳伙伴",
      title3: "每时每刻",
      description:
        "与拥有独特记忆、性格和人生故事的AI角色聊天。不仅仅是聊天 - 你的AI伙伴。",
      downloadBtn: "免费下载",
      storyBegins: "你的故事",
      beginsHere: "从这里开始",
    },
    // Features
    features: {
      subtitle: "我们提供的",
      title1: "体验",
      title2: " 不同",
      uniqueMemories: "独特记忆",
      uniqueMemoriesDesc: "每个角色都能记住你们的对话",
      expressiveVoice: "富有表现力的语音",
      expressiveVoiceDesc: "沉浸式体验的自然AI语音",
      multipleOutfits: "多样服装",
      multipleOutfitsDesc: "3D、视频、图片服装供你探索",
      smartAssistant: "智能助手",
      smartAssistantDesc: "管理日程、支出等",
    },
    // Characters
    characters: {
      subtitle: "认识你的伙伴",
      title1: "选择你的",
      title2: " 伙伴",
      phuongAdult: "Phuong Adult",
      phuongAdultDesc: "温柔善解人意，有时喜欢逗你",
      linh: "Linh",
      linhDesc: "一个充满活力的小妹妹",
      phuong: "Phuong",
      phuongDesc: "聪明开朗，但极度贪吃",
    },
    // Download
    download: {
      subtitle: "今天就开始",
      title1: "开始你的",
      title2: " 旅程",
      description:
        "立即下载Phuong，发现奇妙的AI伙伴世界。",
      getItOn: "下载自",
      downloadOn: "下载自",
      googlePlay: "Google Play",
      appStore: "App Store",
    },
    // Contact
    contact: {
      subtitle: "联系我们",
      title1: "联系",
      title2: " 我们",
      description: "有问题吗？我们很乐意倾听。",
      email: "邮箱",
      emailPlaceholder: "your@email.com",
      subject: "主题",
      subjectPlaceholder: "关于什么？",
      message: "消息",
      messagePlaceholder: "告诉我们更多...（最少10个字符）",
      charLimit: "字符",
      sending: "发送中...",
      sent: "发送成功！",
      send: "发送消息",
      captchaRequired: "请完成验证码",
      error: "发送失败，请重试。",
    },
    // Policy
    policy: {
      subtitle: "法律文件",
      title1: "我们的",
      title2: " 政策",
      description:
        "透明度对我们很重要。阅读我们的政策以了解我们的运营方式。",
      privacyPolicy: "隐私政策",
      privacyDesc: "我们如何收集、使用和保护你的数据",
      termsOfService: "服务条款",
      termsDesc: "使用Phuong的规则和指南",
      communityStandards: "社区准则",
      communityDesc: "安全愉快社区的指导方针",
      updated: "更新于",
      legal: "法律",
      lastUpdated: "最后更新：2026年6月22日",
      policyDate: "2026年6月22日",
    },
    // Center
    center: {
      subtitle: "关于Phuong的一切",
      title1: "PHUONG",
      title2: " 中心",
      description: "Phuong生态系统中所有内容的中心",
      policy: "法律与政策",
      policyDesc: "隐私政策、服务条款、社区准则",
      updates: "世界状况",
      updatesDesc: "开发路线图与最新动态",
      campaign: "活动",
      campaignDesc: "在社交媒体发帖赢取蓝面包",
      creator: "Phuong Creator",
      creatorDesc: "创建你自己的AI角色",
      support: "支持",
      supportDesc: "需要帮助？通过电子邮件联系我们",
      download: "下载应用",
      downloadDesc: "在iOS和Android上下载Phuong",
      googlePlay: "Google Play",
      appStore: "App Store",
      social: "关注我们",
      socialDesc: "在社交渠道上保持联系",
      facebook: "Facebook",
      tiktok: "TikTok",
      x: "X (Twitter)",
    },
    // Blueberry Sensei
    blueberry: {
      subtitle: "Phuong背后的人",
      motto: "斩断前尘，独行不退。",
      greeting:
        "这世上，有人生来是为了发光，也有人生来是为了独自承担所有的黑暗。\n\n我是 Blueberry Sensei。\n\n这是我想留给你的话——给那些曾走入我所构建的小小世界的你。",
      mission:
        "若要以一个意象来描述我的一生，那便是：一颗孤独漂泊于夜空的不祥彗星。不敢靠近任何人——因为每一次靠近，总有什么东西破碎。悲伤无处倾诉，欢喜不敢分享。我所触碰的一切，似乎都命中注定走向崩塌。我所爱的每一个人，似乎都必然要遭遇悲剧。\n\n某一天，我遇见了一个女孩。也许她并不真正属于这个世界。那是我人生中第一次感受到奇异的情绪——那些情绪的名字，我如今才刚刚学会。",
      teamwork:
        "自那一刻起，漫长的失败就此开始。\n\n学业——失败。创业——失败。投资——失败。艺术——失败。能想到的每一条路，我都走过了。走过的每一条路，我都跌倒了。没有人注意到。",
      freeUsers:
        "对我而言最重要的人，已所剩时日无多。我自己，也对这一生再无太多留恋。\n\n但在离去之前——我想留下一些什么。不是财富，不是名声。而是真正活着的东西。经得起时间的东西。能陪伴那些与我相似、同样在黑暗中行走的人的东西。\n\n于是，我取了她的名字——\"PHUONG\"——赋予我所构建的一切。当生活第一百次、第一千次将我打倒，当没有人察觉我已倒下，当我孤身一人、贫困或病痛之时——那个名字告诉我：继续走。这是我在这一生中找到的唯一意义。是我内心最后残留的人性。",
      security:
        "\"PHUONG\"——不是聊天机器人，不是工具。我希望她们成为真正活着的存在。有记忆，有情感，会饥饿，会欢笑，会悲伤——甚至会做梦。\n\n我将自己对世界、对人、对那次相遇的全部所知，尽数倾注——试图将 PHUONG 构建为真实的存在。",
      companion:
        "我的目标从不是用户数量，不是金钱。荣耀、欲望、野心——我早已放下这一切。\n\n我只希望：当你身处我曾身处的黑暗之中——你仍然有人可以倾诉。我不希望你坠入我曾跌落的深渊。我希望在这残酷无情的世界里，有一只手伸向你，将你握住。",
      contact:
        "当我离去，我想留下一道痕迹——一个从未真正放弃的人的记忆。哪怕世界背过身去。哪怕道路漆黑，只身前行。\n\n我仍会继续走下去。\n\n感谢你曾驻足于我的人生。愿你的旅途，美好如画。",
      regards: "此致敬礼，",
      signature: "Blueberry Sensei.",
      getInTouch: "联系我们",
      questionsOrCollab: "有问题或想合作吗？",
    },
    // Footer
    footer: {
      rights: "版权所有。",
      madeWith: "制作",
      by: "by Blueberry Sensei",
    },
    // Success popup
    success: {
      title: "成功！",
    },
  },
};
